/* eslint-disable react/require-default-props */
/* eslint-disable react/no-array-index-key */

import { useCallback, useMemo } from 'react';
import { connect } from 'react-redux';

import CurrencySign from 'components/price/CurrencySign.component';
import S from 'constants/string.const';
import { useTranslation } from 'providers/GILT.provider';
import { selectCurrentSalonCurrency } from 'selectors/currentSalon.selectors';
import asArray from 'utils/arrays/asArray.util';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import currencySign from 'utils/intl/currencySign.util';

import { DownloadExcelButton } from 'reports/Common/DownloadExcelButton';
import { convertToMoneyAfterVat } from 'reports/utils';

import CN from './RevenueByServicesTable.module.scss';

const RevenueByServicesTable = ({ salesReport, startDate, endDate, currentSign }) => {
  const { t } = useTranslation();

  const TABLE_HEADERS = useMemo(() => [t('businessReports.revenueReports.service'), t('businessReports.revenueReports.revenue'), t('businessReports.revenueReports.count')], [t]);

  const createCsv = useCallback(
    () =>
      asArray(salesReport.lastRequestResponse.service_group).map((service) => {
        const values = [service.name, currencySign({ value: service.total.toFixed(2), currentSalonAbbr: currentSign }), service.visits];

        return TABLE_HEADERS.reduce((acc, header, i) => {
          acc[header] = values[i];
          return acc;
        }, {});
      }),
    [currentSign, salesReport.lastRequestResponse.service_group, TABLE_HEADERS],
  );

  const compareServicesByRevenue = (e1, e2) => (e1.total <= e2.total ? 1 : -1);

  const hasTableData = fromAnyToBool(salesReport.lastRequestResponse.service_group.length);

  return (
    <div id="revenue-by-services">
      <div className="t-bgr cfix">
        <div className="t-wrap">
          <div className={CN.tableHeader}>
            <h2>{t('businessReports.revenueReports.revenueByServicesTitle')}</h2>
            <DownloadExcelButton getCsvData={createCsv} fileName={t('businessReports.revenueReports.revenueByServicesFileName')} disabled={!hasTableData} />
          </div>
          <div className="date-in-tbl-for-export">
            {t('businessReports.revenueReports.fromDate')} <strong>{startDate}</strong>
            {S.space}
            {t('businessReports.revenueReports.toDate')} <strong>{endDate}</strong>
          </div>
          <table className="table-reports" id="table-to-xls-revenue-by-services">
            <thead>
              <tr>
                <th className="item-name">{TABLE_HEADERS[0]}</th>
                <th>{TABLE_HEADERS[1]}</th>
                <th>{TABLE_HEADERS[2]}</th>
                <th className="empty-cell" />
              </tr>
            </thead>

            <tbody>
              {salesReport.lastRequestResponse &&
                salesReport.lastRequestResponse.service_group.sort(compareServicesByRevenue).map((sGroup) => (
                  <tr>
                    <td>{sGroup.name}</td>
                    <td>
                      <CurrencySign />
                      {`${convertToMoneyAfterVat(sGroup.total).toFixed(2)}`}
                    </td>
                    <td>{sGroup.visits}</td>
                    <td />
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  const { reports } = state;
  const { salesReport } = reports;
  return {
    salesReport,
    currentSign: selectCurrentSalonCurrency(state),
  };
}

export default connect(mapStateToProps, null)(RevenueByServicesTable);
